import React from 'react';
import styled from 'styled-components';
import { ThreeBounce } from 'styled-spinkit';
import { slideUp } from 'styles/animation';

export const ConversationHeader = styled.div`
  padding: 15px;
  align-items: center;
  display: flex;
  position: relative;
  z-index: 4;
  background: white;
`;

export const AllFilesFooter = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  min-height: 80px;
  background: ${p => p.bgColor};
  z-index: -1;
`;

export const AllFilesListContainer = styled.div`
  box-sizing: border-box;
  box-shadow: 0 13px 15px 0 rgba(80, 80, 80, 0.1);
  width: inherit;
  height: ${p => p.height};
  background-color: white;
  border-radius: 0 0 20px 20px;
  z-index: 1;
  transition: 0.05s all ease-in;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 162px);
  overflow-y: overlay;
  margin-top: -1px;
  min-width: 100%;
`;

export const NoFilesFoundDiv = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 17px;
  color: #2F3C4E;
  mix-blend-mode: normal;
  opacity: 0.8;
`

ConversationHeader.displayName = 'ConversationHeader';

export const ConversationHeaderDetail = styled.div`
  padding: 15px 15px 0 15px;
  box-shadow: 0 5px 15px 0 rgba(80, 80, 80, 0.1);
  position: absolute;
  z-index: 23;
  background: white;
  top: 0;
  left: 0;
  min-height: 80px;
  width: 100%;
  box-sizing: border-box;
`;

export const AllFilesHeader = styled.div`
    display: flex;
  margin: 0 auto;
  padding-right: 2rem;
`;

export const AllFilesHeaderText = styled.div`
  font-size: 10px;
  line-height: 12px;
  color: #000000;
  margin-left: 6px;
`

export const HeaderDetailCloseIcon = styled.img`
  width: 11px;
  height: 11px;
  padding: 10px 0 10px 10px;
  cursor: pointer;
`;

export const HeaderDetailHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  color: black;
`;

export const HeaderDetailListItem = styled.div`
  display: flex;
  align-items: center;
  margin-left: 15px;
  margin-bottom: 15px;
`;

export const ConversationDetailContainer = styled.div`
  display: block;
  z-index: -2;
`;

ConversationDetailContainer.displayName = 'ConversationDetailContainer';

export const MoreIconVerticalImageHolder = styled.div`
  width: 10px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  cursor: pointer;
`

export const MoreIconVerticalImage = styled.img`
`

export const ConversationDetail = styled.div`
  box-sizing: border-box;
  box-shadow: 0 13px 15px 0 rgba(80, 80, 80, 0.1);
  width: inherit;
  height: ${p => p.height};
  background-color: white;
  border-radius: 0 0 20px 20px;
  z-index: 1;
  transition: 0.05s all ease-in;
  display: flex;
  overflow-y: overlay;
  margin-top: -1px;
  min-width: 100%;
`;

ConversationDetail.displayName = 'ConversationDetail';

export const ConversationWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const ConversationList = styled.div`
  position: relative;
  overflow: auto;
  padding: 1.2rem 0 1.2rem;
  width: 100%;
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #49546526;
    opacity: 0.15;
    border-radius: 30px;
  }
`;
export const ConversationBackIcon = styled.img`
  margin: 0 auto;
  width: 9px;
  height: 15px;
`;

export const AZoomInfoCompany = styled.span`
  font-size: 8px;
  color : #A9AEB9;
  margin-left: 4px;
  line-height: 7.11px;
  margin-top: 4px;
`

ConversationBackIcon.displayName = 'ConversationBackIcon';

export const ConversationBackButton = styled.div`
  height: 50px;
  margin-right: 1rem;
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: pointer;
`;

export const AllFilesCloseButton = styled.div`
  height: 50px;
  margin-right: 1rem;
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: pointer;
`

ConversationBackButton.displayName = 'ConversationBackButton';

export const NewMessageDot = styled(({ headerTextColor, children, ...others }) => (
  <div {...others}>{children}</div>
))`
  position: fixed;
  top: -1.5px;
  right: -1.5px;
  background-color: ${p => p.headerTextColor || 'red'};
  width: 10px;
  height: 10px;
  border-radius: 50%;
`;

NewMessageDot.displayName = 'NewMessageDot';

export const ConversationHeaderLogo = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 100%;
  margin-left: 0.5rem;
`;

ConversationHeaderLogo.displayName = 'ConversationHeaderLogo';

export const TypingIndicator = styled(ThreeBounce)`
  position: absolute;
  margin: 1px 50px;
`;

TypingIndicator.displayName = styled(TypingIndicator);

export const NotificationContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: 9;
  margin-top: 0.5rem;
`;

NotificationContainer.displayName = 'NotificationContainer';

export const AgentSenderMessageWrapper = styled.div`
  margin-left: 0.69rem;
  width: 100%;
`;

export const AgentName = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  max-width: 70%;
  max-height: 2.5rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: flex;
`;

export const AgentLinkedinIcon = styled.img`
  margin-left: 0.25rem;
`;

export const AgentTitle = styled.div`
  font-size: 10px;
  opacity: 0.6;
  margin: 1px 0;
  margin-right: 30px;
`;

export const AgentHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderDropdown = styled.img`
  margin-left: 5px;
  padding: 5px;
  cursor: pointer;
`;

export const LinkIframe = styled.div`
  bottom: 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  right: 0;
  background-color: white;
  border-radius: 20px;
  iframe {
    border: 0;
    width: 100%;
    height: calc(100% - 75px);
    border-radius: 0 0 10px 10px;
  }
  opacity: 0;
  transform: translateY(10px);
  animation: ${slideUp} 0.4s ease-in-out 0.15s forwards;
`;

export const LinkFrameLoading = styled.div`
  height: calc(100% - 75px);
`;

export const LinkIframeHeader = styled.div`
  color: white;
  display: flex;
  padding-left: 10px;
  height: 80px;
  background-color: white;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 5px 15px 0 rgba(80, 80, 80, 0.1);
`;

export const LinkIframeCloseButton = styled.button`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 0;

  &:focus {
    outline: none;
  }
`;

export const LinkBackIcon = styled.img`
  margin: 0 auto;
  width: 9px;
  height: 15px;
`;

export const LinkBackButton = styled.div`
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  align-items: center;
  transform: translateZ(0);
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

export const LoadingWrapper = styled.div`
  position: relative;
  width: 100%;
  height:100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

